import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=02c7e4b6&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02c7e4b6')) {
      api.createRecord('02c7e4b6', component.options)
    } else {
      api.reload('02c7e4b6', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=02c7e4b6&", function () {
      api.rerender('02c7e4b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/users/Create.vue"
export default component.exports